export const MULTI_CLASS_SELECT_LEARNERS_KEY = "rapidRoster:multiClassSelectLearners";
